import { MenuItem } from "./menuitem.model";

export class Menu {

    public separatorItems: MenuItem[];

    constructor(){
        this.separatorItems = [];
    }

}